import {
  MENUHUNTER_BRAND_ORANGE,
  type MenuHunterMarkVariant,
} from "@menuhunter/ui/brand";
import { MenuHunterMark } from "./MenuHunterMark";

export type MenuHunterLockupProps = {
  /** Mark diameter in px. */
  markSize?: number;
  /** Wordmark font size in px (Tailwind arbitrary or inline). */
  wordmarkClassName?: string;
  markClassName?: string;
  className?: string;
  /** Horizontal (nav) vs stacked (auth / hero). Default horizontal. */
  layout?: "horizontal" | "stacked";
  accentColor?: string;
  arcColor?: string;
  variant?: MenuHunterMarkVariant;
  strokeWidth?: number;
  /** Hide the text wordmark (mark only). */
  markOnly?: boolean;
  /** Show wordmark only from this breakpoint (e.g. min-[400px]:inline). */
  wordmarkVisibilityClassName?: string;
};

/**
 * Canonical MenúHunter brand lockup for Web UI.
 * Mark uses approved theme-aware arcs; wordmark uses navy / white via `dark:`.
 */
export function MenuHunterLockup({
  markSize = 42,
  wordmarkClassName,
  markClassName,
  className,
  layout = "horizontal",
  accentColor = MENUHUNTER_BRAND_ORANGE,
  arcColor,
  variant,
  strokeWidth,
  markOnly = false,
  wordmarkVisibilityClassName = "hidden min-[400px]:inline",
}: MenuHunterLockupProps) {
  const resolvedVariant =
    variant ?? (markSize <= 28 ? "micro" : "master");
  const isStacked = layout === "stacked";

  return (
    <span
      className={
        className ??
        (isStacked
          ? "inline-flex flex-col items-center"
          : "inline-flex items-center gap-2")
      }
    >
      <MenuHunterMark
        size={markSize}
        accentColor={accentColor}
        arcColor={arcColor}
        variant={resolvedVariant}
        strokeWidth={strokeWidth}
        className={markClassName ?? "shrink-0"}
      />
      {!markOnly ? (
        <span
          className={
            wordmarkClassName ??
            (isStacked
              ? "mt-3 font-bold text-[#0F172A] dark:text-white tracking-wide text-lg"
              : `font-semibold text-[#0F172A] dark:text-white text-sm sm:text-base ${wordmarkVisibilityClassName}`)
          }
        >
          MenúHunter
        </span>
      ) : null}
    </span>
  );
}
